import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

// Components
import PayoutBillingDetails from './PayoutBillingDetails';
import PayoutConfirm from './PayoutConfirm';
import PayoutMethods from './PayoutMethods';

const PayoutForm = ({ initialValues }) => {

  const [page, setPage] = useState(1);

  const nextPage = () => {
    setPage(page + 1)
  }

  const previousPage = () => {
    setPage(page - 1)
  }

  return (
    <div className={'payoutStepBg'}>
      {
        page === 1 && <PayoutBillingDetails
          onSubmit={nextPage}
          initialValues={initialValues}
        />
      }
      {
        page === 2 && <PayoutMethods
          previousPage={previousPage}
          onSubmit={nextPage}
          initialValues={initialValues}
        />
      }
      {
        page === 3 && <PayoutConfirm
          previousPage={previousPage}
          onSubmit={nextPage}
          initialValues={initialValues}
        />
      }
    </div>
  );
}

PayoutForm.propTypes = {
  initialValues: PropTypes.object.isRequired
};

export default reduxForm({
  form: 'PayoutForm', // a unique name for this form
  destroyOnUnmount: true,
})(PayoutForm);